import { BankIdApiAuthDto } from "@api-types/integrations/BankIdApiAuthDto";
import { getWebApiUrl, httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getMvcRequestHeaders } from "@utils/api-config/getMvcRequestHeaders";
import { ApiRequestContextData } from "@utils/api-config/types";

export class BankIdMvcService {
	private static get baseUrl(): string {
		return `${getWebApiUrl()}/api/bankid`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null = getApiRequestContext()
	): HeadersInit => {
		const appHeaders = getMvcRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		appHeaders["Web-Device" as keyof HeadersInit] = "CapacitorApp";
		return appHeaders;
	};

	static async getInitialQrCodeData(): Promise<BankIdApiAuthDto> {
		const headers = this.getRequestHeaders();
		const url = `${this.baseUrl}/qrcode`;

		return httpClient.get(url, { ...headers });
	}

	static async getRefreshedQrCode(qrId: string) {
		const headers = this.getRequestHeaders();
		const url = `${this.baseUrl}/qrcode/${qrId}`;

		return httpClient.get(url, { ...headers }, { responseType: "raw" });
	}
}
